interface Props {
  selected: boolean;
}
const SvgAuthPhone: React.FC<Props> = ({ selected }) => {
  return (
    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_13217_358)">
        <path
          d="M12.125 17.375H6.875C5.83963 17.375 5 16.5354 5 15.5V3.5C5 2.46463 5.83963 1.625 6.875 1.625H12.125C13.1604 1.625 14 2.46463 14 3.5V15.5C14 16.5354 13.1604 17.375 12.125 17.375ZM12.5 9.5V3.875C12.5 3.46062 12.1644 3.125 11.75 3.125H7.25C6.83562 3.125 6.5 3.46062 6.5 3.875V9.5C6.5 9.91438 6.83562 10.25 7.25 10.25H11.75C12.1644 10.25 12.5 9.91438 12.5 9.5ZM6.5 12.6875C6.5 12.9987 6.75125 13.25 7.0625 13.25H8V12.125H7.0625C6.75125 12.125 6.5 12.3763 6.5 12.6875ZM8.75 13.25H10.25V12.125H8.75V13.25ZM11.9375 12.125H11V13.25H11.9375C12.2488 13.25 12.5 12.9987 12.5 12.6875C12.5 12.3763 12.2488 12.125 11.9375 12.125ZM6.5 14.9375C6.5 15.2487 6.75125 15.5 7.0625 15.5H8V14.375H7.0625C6.75125 14.375 6.5 14.6263 6.5 14.9375ZM8.75 15.5H10.25V14.375H8.75V15.5ZM11.9375 14.375H11V15.5H11.9375C12.2488 15.5 12.5 15.2487 12.5 14.9375C12.5 14.6263 12.2488 14.375 11.9375 14.375Z"
          fill={selected ? "white" : "#2B2B2B"}
        />
      </g>
      <defs>
        <clipPath id="clip0_13217_358">
          <rect width="18" height="18" fill="white" transform="translate(0.5 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgAuthPhone;
